import styled from "styled-components";

interface styleProps {
  $isActive?: boolean;
}

export const IconBox = styled.div<styleProps>`
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  display: flex;

  svg {
    fill: ${(props) => (props.$isActive ? "#F97316" : "#9CA3AF")};
  }
`;

export const InputNum = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #525252;
  width: 100%;
  font-weight: 500;

  &::placeholder {
    color: #d4d4d4;
  }
`;
